import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

// External Libraries
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet, HelmetProvider } from "react-helmet-async";

// React Bootstrap
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Container,
  Carousel,
  Badge,
  Alert,
} from "react-bootstrap";

import axios from "axios";
import Apiurl from "../environments/Apiurl";
import ImageApi from "../environments/ImageApi";

// React Icons
import {
  FaLaptopCode,
  FaMobileAlt,
  FaShoppingCart,
  FaCogs,
  FaAward,
  FaHandshake,
  FaPuzzlePiece,
  FaRocket,
  FaUserCheck,
  FaBriefcase,
  FaGraduationCap,
} from "react-icons/fa";
import { FiArrowUpRight } from "react-icons/fi";

// Assets (Images, Videos, CSS)
import "../../assest/css/Home.css";
import AboutSection from "../../assest/image/Home/Home - About Section.jpg";
import WhyChooseusSection from "../../assest/image/Home/Home - Why Choose Us.jpg";
import PromotionSection from "../../assest/image/Home/Home  - Software Courses in Salem.jpg";

// Review Images (Fallback if needed)
import review1 from "../../assest/image/Home/review image/review 3.png";

// Client Logos (Fallback static if backend fails)
import Clients1 from "../../assest/image/Home/Clients/Clients (1).jpg";
import Clients2 from "../../assest/image/Home/Clients/Clients (2).jpg";
import Clients3 from "../../assest/image/Home/Clients/Clients (3).jpg";
import Clients4 from "../../assest/image/Home/Clients/Clients (4).png";
import Clients5 from "../../assest/image/Home/Clients/Clients (5).png";
import Clients6 from "../../assest/image/Home/Clients/Clients (6).png";
import Clients7 from "../../assest/image/Home/Clients/Clients (7).png";
import Clients8 from "../../assest/image/Home/Clients/Clients (8).png";
import Clients9 from "../../assest/image/Home/Clients/Clients (9).png";
import Clients10 from "../../assest/image/Home/Clients/Clients (10).png";
import Clients11 from "../../assest/image/Home/Clients/Clients (11).png";
import Clients12 from "../../assest/image/Home/Clients/Clients (12).png";

// Videos
import academyvideo from "../../assest/video/Businessman with Artificial Intelligence, Hologram, Stock Footage.mp4";

// Blog Fallback Image
import BlogImage from "../../assest/image/Portfolio/Social/Social (1).jpg";

// Components
import Footer from "../Footer/Footer";

// API Config
import data from "../../Meta/Meta_ApiUrl";

const Home = () => {
  const [meta, setMeta] = useState({});
  const [courses, setCourses] = useState([]);
  const [courseReviews, setCourseReviews] = useState([]); // New state for dynamic reviews
  const [clients, setClients] = useState([]); // Dynamic clients state
  const [getData, setGetData] = useState([]); // Blog data
  const sliderRef = useRef(null);

  const fallbackClients = [
    { src: Clients1, alt: "Client 1" },
    { src: Clients2, alt: "Client 2" },
    { src: Clients3, alt: "Client 3" },
    { src: Clients4, alt: "Client 4" },
    { src: Clients5, alt: "Client 5" },
    { src: Clients6, alt: "Client 6" },
    { src: Clients7, alt: "Client 7" },
    { src: Clients8, alt: "Client 8" },
    { src: Clients9, alt: "Client 9" },
    { src: Clients10, alt: "Client 10" },
    { src: Clients11, alt: "Client 11" },
    { src: Clients12, alt: "Client 12" },
  ];

  const courses1 = [
    { id: 1, title: "Python Full Stack Development" },
    { id: 2, title: "Java Full Stack Development" },
    { id: 3, title: "MERN Stack Development" },
    { id: 4, title: "MEAN Stack Development" },
    { id: 5, title: "Mobile App Development" },
    { id: 6, title: "Data Analysis" },
    { id: 7, title: "UI/UX Design" },
    { id: 8, title: "AWS Cloud" },
    { id: 9, title: "DevOps Engineering" },
  ];

  useEffect(() => {
    const HomeMeta = data[0]?.home_page;
    if (HomeMeta) {
      setMeta(HomeMeta);
    }
  }, []);

  // Consolidated fetch for all data in parallel
  useEffect(() => {
    const fetchAllData = async () => {
      const [coursesRes, reviewsRes, clientsRes, blogsRes] = await Promise.all([
        axios.get(`${Apiurl}/courses`).catch(() => ({ data: courses1 })),
        axios.get(`${Apiurl}/review/course-review`).catch(() => ({ data: [] })),
        axios.get(`${Apiurl}/portfolio/clients`).catch(() => ({ data: [] })),
        axios
          .get(`${Apiurl}/blog/blog-card`)
          .catch(() => ({ data: { blogs: [] } })),
      ]);

      setCourses(coursesRes.data);
      setCourseReviews(reviewsRes.data);
      console.log("Fetched course reviews:", reviewsRes.data);

      const dynamicClients = clientsRes.data.map((client, index) => ({
        src: `${ImageApi}${client.client_logo}`,
        alt: `Client ${index + 1}`,
        id: client._id,
      }));
      setClients(dynamicClients.length > 0 ? dynamicClients : fallbackClients);
      console.log("Fetched clients from backend:", clientsRes.data);

      setGetData(blogsRes.data.blogs || []);
      console.log("Get Blog Cards Data", blogsRes.data);
    };

    fetchAllData();
  }, []);

  const navigate = useNavigate();
  const [currentHeroSlide, setCurrentHeroSlide] = useState(0);
  const [startCount, setStartCount] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: true, // Unified to once: true for better perf (animations run once)
      offset: 100,
      delay: 100,
    });
  }, []);

  const heroSlides = [
    {
      id: 1,
      subheadline: "Aalan Tech Soft",
      paragraph:
        "We are a team of highly skilled and experienced professionals dedicated to delivering top notch Software Development to clients across different industries.",
      btn: "Contact Us",
      onclick: "/contactus",
    },
    {
      id: 2,
      subheadline: "Transform Your Career with Expert-Led Courses in Salem",
      paragraph:
        "Comprehensive courses, hands on projects, and real-world training designed for Salem students and job seekers.",
      btn: "Explore Our Courses",
      onclick: "/courses",
    },
    {
      id: 3,
      subheadline: "ATS  Your Trusted Software Development Partner in Salem",
      paragraph:
        "We are Specialized in Creating Custom Software Application for Bussinesses and individuals.",
      btn: "Explore services",
      onclick: "/services",
    },
  ];

  // Auto slide text every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentHeroSlide((prevIndex) =>
        prevIndex === heroSlides.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);
    return () => clearInterval(interval);
  }, [heroSlides.length]);

  const handlePrev = () => {
    setCurrentHeroSlide(
      currentHeroSlide === 0 ? heroSlides.length - 1 : currentHeroSlide - 1
    );
  };

  const handleNext = () => {
    setCurrentHeroSlide(
      currentHeroSlide === heroSlides.length - 1 ? 0 : currentHeroSlide + 1
    );
  };

  useEffect(() => {
    const handleScroll = () => {
      const triggerPoint = window.innerHeight / 1.3;
      const statsSection = document.getElementById("stats-section");
      if (
        statsSection &&
        statsSection.getBoundingClientRect().top < triggerPoint
      ) {
        setStartCount(true);
        window.removeEventListener("scroll", handleScroll);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    course: "",
    learningMode: "",
  });
  const [submitMessage, setSubmitMessage] = useState("");
  const [submitError, setSubmitError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (submitError) setSubmitError("");
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (formData.phone.length !== 10) {
      setSubmitError("Phone number must be exactly 10 digits.");
      return;
    }
    if (!formData.course || !formData.learningMode) {
      setSubmitError("Please select a course and learning mode.");
      return;
    }

    setIsSubmitting(true);
    setSubmitError("");
    setSubmitMessage("");

    // Map to backend format
    const payload = {
      name: formData.name.trim(),
      email: formData.email.trim(),
      phone_number: formData.phone.trim(),
      interested_course: formData.course,
      preferred_mode: formData.learningMode,
      source: "website", // Track origin
    };

    try {
      const response = await axios.post(`${Apiurl}/course-enquiries`, payload);
      console.log("✅ Submitted:", response.data);
      setSubmitMessage("Registration successful! We'll contact you soon.");
      setFormData({
        name: "",
        email: "",
        phone: "",
        course: "",
        learningMode: "",
      });
    } catch (err) {
      console.error("❌ Error:", err);
      setSubmitError(
        err.response?.data?.message || "Failed to register. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const [expanded, setExpanded] = useState({});

  const toggleReadMore = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const setting = {
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 2000, // Changed from 0 to 2000ms for pause, reduces rapid re-renders
    cssEase: "linear",
    pauseOnHover: true, // Added for better UX and perf
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 425, settings: { slidesToShow: 1 } },
    ],
  };

  const Clientsetting = {
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    speed: 5000,
    autoplaySpeed: 2000, // Changed from 0 to 2000ms for pause
    cssEase: "linear",
    pauseOnHover: true, // Added
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settingss = {
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
  };

  // Get the latest 3 blogs sorted by post_date descending
  const recentPosts = getData
    .sort((a, b) => new Date(b.post_date) - new Date(a.post_date))
    .slice(0, 3);

  // Clean up the cover_image URL to fix case sensitivity and extra slashes
  const cleanImageUrl = (url) => {
    if (!url) return BlogImage;
    return url
      .replace(/^\/+/, "") // Remove leading slashes
      .replace(/uploads/i, "uploads") // Ensure lowercase 'uploads'
      .replace(/\/uploads\/+uploads\//i, "/uploads/") // Fix double uploads if any
      .replace(/^(.*\/)uploads\//i, "$1uploads/"); // Ensure single uploads
  };

  // Clean up review image URL similarly
  const cleanReviewImageUrl = (url) => {
    if (!url) return review1;
    let cleaned = url
      .replace(/^\/+/, "") // Remove leading slashes
      .replace(/uploads/i, "uploads") // Ensure lowercase 'uploads'
      .replace(/\/uploads\/+uploads\//i, "/uploads/") // Fix double uploads if any
      .replace(/^(.*\/)uploads\//i, "$1uploads/"); // Ensure single uploads
    return `${ImageApi}/${cleaned}`;
  };

  return (
    <HelmetProvider>
      <div className="home-container">
        <Helmet>
          <title>{meta?.title || "Home - Aalan Techsoft"}</title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Whether you're a beginner or upskilling, our practical training lets you apply your knowledge and create a strong portfolio."
            }
          />
        </Helmet>
        <main>
          {/* Hero Section */}
          <section
            className="hero-section position-relative"
            style={{ height: "100vh" }}
          >
            <video
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{ objectFit: "cover", zIndex: -1 }}
              autoPlay
              loop
              muted
              playsInline
              preload="metadata" // Optimized preload to reduce initial load
            >
              <source src={academyvideo} type="video/mp4" />
            </video>
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                background: "rgba(0,0,0,0.5)",
                zIndex: -1,
              }}
            ></div>
            <div
              id="heroCarousel"
              className="carousel slide"
              data-bs-ride="false"
              data-bs-interval="false"
            >
              <div className="carousel-inner">
                {heroSlides.map((slide, index) => (
                  <div
                    key={slide.id}
                    className={`carousel-item ${
                      index === currentHeroSlide ? "active" : ""
                    }`}
                  >
                    <Container className="h-100">
                      <Row className="h-100 align-items-center justify-content-center text-center text-white">
                        <Col lg={8}>
                          <h1 className="mb-3">{slide.subheadline}</h1>
                          <p className="mb-4">{slide.paragraph}</p>
                          <div className="d-flex flex-wrap gap-3 justify-content-center">
                            <Button
                              className="Hero-btn mt-4 shadow-sm"
                              onClick={() => navigate(slide.onclick)}
                            >
                              {slide.btn}
                              <span className="Hero-btn-icon ms-2">
                                <FiArrowUpRight />
                              </span>
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                ))}
              </div>
              <button
                className="carousel-control-prev custom-arrow"
                type="button"
                onClick={handlePrev}
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next custom-arrow"
                type="button"
                onClick={handleNext}
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
            <style>
              {`
      .hero-btn {
        background-color: #85bf39;
        color: #fff;
        border: none;
        padding: 8px 28px;
        font-size: 1rem;
        border-radius: 6px;
      }
      .custom-arrow .carousel-control-prev-icon,
      .custom-arrow .carousel-control-next-icon {
        width: 30px;
        height: 30px;
      }
      @media (max-width: 576px) {
        .hero-section {
          height: 60vh !important;
        }
        .hero-section .carousel-item {
          height: 60vh !important;
        }
        .hero-btn {
          width: 100%;
          font-size: 0.9rem;
          padding: 10px 0;
        }
        .custom-arrow {
          top: auto;
          bottom: 15px;
          transform: scale(0.8);
        }
      }
      @media (min-width: 577px) {
        .hero-section {
          height: 100vh !important;
        }
        .hero-section .carousel-item {
          height: 100vh !important;
        }
      }
    `}
            </style>
          </section>

          {/* About Section */}
          <section className="about-section position-relative py-5">
            <Container>
              <Row className="align-items-center gx-5">
                <Col lg={6} data-aos="fade-up" data-aos-duration="1200">
                  <h2
                    className="section-title fw-bold display-5 mb-3"
                    data-aos="fade-right"
                    data-aos-delay="100"
                  >
                    <span className="badge-title">Who We Are</span>
                  </h2>
                  <h2
                    className="section-title mb-3"
                    data-aos="fade-right"
                    data-aos-delay="100"
                  >
                    About{" "}
                    <span style={{ color: "#85bf39" }}>Aalan TechSoft</span>
                  </h2>
                  <p
                    className="section-text"
                    style={{ textAlign: "justify" }}
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    Welcome to Aalan TechSoft (ATS), your trusted partner for
                    software development and IT training in Salem. We specialize
                    in building innovative software solutions and offer
                    expert led training programs in Full Stack Development, MEAN
                    Stack, Python, Java, Angular, and more.
                  </p>

                  <p
                    className="section-text justify-text"
                    style={{ textAlign: "justify" }}
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    At ATS, we go beyond teaching we focus on creating career
                    opportunities for college students and job seekers in Salem.
                    Our hands on projects and industry focused courses ensure
                    you gain the skills needed to excel in today's competitive
                    IT world. Whether you're looking for reliable software
                    solutions or aiming to start a rewarding IT career in Salem,
                    Aalan TechSoft is here to guide you every step of the way.
                  </p>

                  <Button
                    className="custom-btn mt-4 shadow-sm"
                    onClick={() => {
                      navigate("/about-us");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    data-aos="zoom-in"
                    data-aos-delay="100"
                  >
                    <span className="btn-text fw-semibold">Discover More</span>
                    <span className="btn-icon ms-2">
                      <FiArrowUpRight />
                    </span>
                  </Button>
                </Col>
                <Col
                  lg={6}
                  data-aos="zoom-in-up"
                  data-aos-duration="1500"
                  className="position-relative mt-4 mt-lg-0"
                >
                  <div className="about-img-wrapper position-relative">
                    <img
                      src={AboutSection}
                      alt="Modern education facility"
                      className="img-fluid rounded-4 shadow"
                      loading="lazy" // Added lazy loading
                    />
                    <div
                      className="bg-shape"
                      data-aos="flip-left"
                      data-aos-delay="100"
                    ></div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          {/* Service Section */}
          <section className="solutions-section py-5 text-center bg-light">
            <Container>
              <Row
                className="justify-content-center text-center mb-5"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <Col md={10} className="text-center mx-auto">
                  <span
                    className="badge-title"
                    data-aos="zoom-in"
                    data-aos-delay="100"
                  >
                    Our Services
                  </span>
                  <h2
                    className="section-title mt-3"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    Elevate Your Vision with <br /> Our Premier Software
                    Development Services
                  </h2>
                  <p
                    className="Section-text"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    Empowering your business with ATS Software Development &
                    Trainings and expert services.
                    <br />
                    Simplify operations, boost efficiency, and achieve your
                    goals effortlessly.
                  </p>
                  <div className="d-flex justify-content-center mt-4">
                    <Button
                      className="custom-btn shadow-sm"
                      onClick={() => {
                        navigate("/services");
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                      data-aos="zoom-in-up"
                      data-aos-delay="100"
                    >
                      <span className="btn-text fw-semibold">All Services</span>
                      <span className="btn-icon ms-2">
                        <FiArrowUpRight />
                      </span>
                    </Button>
                  </div>
                </Col>
              </Row>
              {!isMobile && (
                <Row>
                  <Col
                    md={6}
                    lg={3}
                    className="mb-4"
                    data-aos="flip-left"
                    data-aos-delay="100"
                    data-aos-duration="1200"
                  >
                    <Card className="service-card h-100 text-start">
                      <Card.Body>
                        <div
                          className="service-icon "
                          style={{ color: "#85bf39" }}
                        >
                          <FaLaptopCode />
                        </div>
                        <h5 className="card-title">Web Development</h5>
                        <p className="card-text">
                          Unlock the Full Potential of Your Online Presence with
                          Our Comprehensive Web Development Services. From
                          Static Websites to Responsive Dynamic Website
                          Solutions, We Craft Innovative Solutions for Your
                          Digital Success.
                        </p>
                        <a href="/services" className="read-more">
                          Read More →
                        </a>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col
                    md={6}
                    lg={3}
                    className="mb-4"
                    data-aos="flip-right"
                    data-aos-delay="100"
                    data-aos-duration="1200"
                  >
                    <Card className="service-card h-100 text-start">
                      <Card.Body>
                        <div
                          className="service-icon"
                          style={{ color: "#85bf39" }}
                        >
                          <FaMobileAlt />
                        </div>
                        <h5 className="card-title">App Development</h5>
                        <p className="card-text">
                          Diversify your digital presence with our
                          cross platform expertise in mobile app development.
                          From iOS to Android and beyond, we specialize in
                          creating versatile applications that cater to all
                          major platforms.
                        </p>
                        <a href="/services" className="read-more">
                          Read More →
                        </a>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col
                    md={6}
                    lg={3}
                    className="mb-4"
                    data-aos="flip-left"
                    data-aos-delay="100"
                    data-aos-duration="1200"
                  >
                    <Card className="service-card h-100 text-start">
                      <Card.Body>
                        <div
                          className="service-icon"
                          style={{ color: "#85bf39" }}
                        >
                          <FaShoppingCart />
                        </div>
                        <h5 className="card-title">E-Commerce</h5>
                        <p className="card-text">
                          Enhance your online presence with our expert
                          e-commerce development. We deliver seamless user
                          experiences, secure payment gateways, and optimized
                          performance to elevate your online store and drive
                          sales.
                        </p>
                        <a href="/services" className="read-more">
                          Read More →
                        </a>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col
                    md={6}
                    lg={3}
                    className="mb-4"
                    data-aos="flip-right"
                    data-aos-delay="100"
                    data-aos-duration="1200"
                  >
                    <Card className="service-card h-100 text-start">
                      <Card.Body>
                        <div
                          className="service-icon"
                          style={{ color: "#85bf39" }}
                        >
                          <FaCogs />
                        </div>
                        <h5 className="card-title">Customized Software</h5>
                        <p className="card-text">
                          Enhance your business operations with our tailored
                          software solutions. We deliver secure, scalable, and
                          efficient systems designed to streamline workflows,
                          boost productivity, and accelerate growth.
                        </p>
                        <a href="/services" className="read-more">
                          Read More →
                        </a>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )}
              {isMobile && (
                <Slider {...settingss} className="mobile-slider">
                  <div className="px-2" data-aos="zoom-in" data-aos-delay="100">
                    <Card className="service-card text-start">
                      <Card.Body>
                        <div
                          className="service-icon"
                          style={{ color: "#85bf39" }}
                        >
                          <FaLaptopCode />
                        </div>
                        <h5 className="card-title">Web Development</h5>
                        <p className="card-text">
                          Unlock the Full Potential of Your Online Presence with
                          Our Comprehensive Web Development Services. From
                          Static Websites to Responsive Dynamic Website
                          Solutions, We Craft Innovative Solutions for Your
                          Digital Success.
                        </p>
                        <a href="/services" className="read-more">
                          Read More →
                        </a>
                      </Card.Body>
                    </Card>
                  </div>
                  <div className="px-2" data-aos="zoom-in" data-aos-delay="100">
                    <Card className="service-card text-start">
                      <Card.Body>
                        <div
                          className="service-icon"
                          style={{ color: "#85bf39" }}
                        >
                          <FaMobileAlt />
                        </div>
                        <h5 className="card-title">App Development</h5>
                        <p className="card-text">
                          Diversify your digital presence with our
                          cross-platform expertise in mobile app development.
                          From iOS to Android and beyond, we specialize in
                          creating versatile applications that cater to all
                          major platforms.
                        </p>
                        <a href="/services" className="read-more">
                          Read More →
                        </a>
                      </Card.Body>
                    </Card>
                  </div>
                  <div className="px-2" data-aos="zoom-in" data-aos-delay="100">
                    <Card className="service-card text-start">
                      <Card.Body>
                        <div
                          className="service-icon"
                          style={{ color: "#85bf39" }}
                        >
                          <FaShoppingCart />
                        </div>
                        <h5 className="card-title">E-Commerce</h5>
                        <p className="card-text">
                          Enhance your online presence with our expert
                          e-commerce development. We deliver seamless user
                          experiences, secure payment gateways, and optimized
                          performance to elevate your online store and drive
                          sales.
                        </p>
                        <a href="/services" className="read-more">
                          Read More →
                        </a>
                      </Card.Body>
                    </Card>
                  </div>
                  <div className="px-2" data-aos="zoom-in" data-aos-delay="100">
                    <Card className="service-card text-start">
                      <Card.Body>
                        <div
                          className="service-icon"
                          style={{ color: "#85bf39" }}
                        >
                          <FaCogs />
                        </div>
                        <h5 className="card-title">Customized Software</h5>
                        <p className="card-text">
                          Enhance your business operations with our tailored
                          software solutions. We deliver secure, scalable, and
                          efficient systems designed to streamline workflows,
                          boost productivity, and accelerate growth.
                        </p>
                        <a href="/services" className="read-more">
                          Read More →
                        </a>
                      </Card.Body>
                    </Card>
                  </div>
                </Slider>
              )}
            </Container>
          </section>

          {/* Why Choose Us Section */}
          <section className="why-choose-us py-5 ">
            <Container>
              <Row
                className="justify-content-center text-center mb-5"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <Col xs={12} md={10} className="mx-auto">
                  <span
                    className="badge-title"
                    data-aos="zoom-in"
                    data-aos-delay="100"
                  >
                    Why Choose Us
                  </span>
                  <h2
                    className="section-title mt-3"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    We Are Here to Grow Your Business Exponentially
                  </h2>
                  <p
                    className="section-text text-center"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    Choose us for software development & services that ensure
                    your goals are not just met but exceeded.
                  </p>
                </Col>
              </Row>
              <Row className="align-items-center ">
                <Col
                  xs={12}
                  lg={6}
                  data-aos="zoom-in"
                  data-aos-duration="1200"
                  className="mt-4 mt-lg-0"
                >
                  <div className="about-img-wrapper position-relative">
                    <img
                      src={WhyChooseusSection}
                      alt="Modern education facility"
                      className="img-fluid rounded-4 shadow"
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "auto",
                      }}
                      loading="lazy" // Added lazy loading
                    />
                  </div>
                </Col>
                <Col xs={12} lg={6} className="d-flex mt-md-4 mt-4">
                  <Row className="justify-content-center flex-fill">
                    <Col
                      xs={12}
                      sm={6}
                      lg={6}
                      className="mb-4"
                      data-aos="flip-left"
                      data-aos-delay="100"
                      data-aos-duration="1200"
                    >
                      <div className="feature-card-custom text-center p-4 h-100 rounded-4 shadow-sm">
                        <div className="feature-icon-wrapper mb-3 mx-auto">
                          <FaAward />
                        </div>
                        <h5 className="fw-bold mb-2 card-title">
                          Best in Industry
                        </h5>
                        <p className="card-text">
                          Exemplary Excellence: Setting industry standards with
                          our best-in-class software development services.
                        </p>
                      </div>
                    </Col>
                    <Col
                      xs={12}
                      sm={6}
                      lg={6}
                      className="mb-4"
                      data-aos="flip-right"
                      data-aos-delay="100"
                      data-aos-duration="1200"
                    >
                      <div className="feature-card-custom text-center p-4 h-100 rounded-4 shadow-sm">
                        <div className="feature-icon-wrapper mb-3 mx-auto">
                          <FaHandshake />
                        </div>
                        <h5 className="fw-bold mb-2 card-title">
                          Seamless Solutions
                        </h5>
                        <p className="card-text">
                          Promising smooth collaboration, outstanding service,
                          and unparalleled experience in software excellence.
                        </p>
                      </div>
                    </Col>
                    <Col
                      xs={12}
                      sm={6}
                      lg={6}
                      className="mb-4"
                      data-aos="fade-up-right"
                      data-aos-delay="100"
                      data-aos-duration="1200"
                    >
                      <div className="feature-card-custom text-center p-4 h-100 rounded-4 shadow-sm">
                        <div className="feature-icon-wrapper mb-3 mx-auto">
                          <FaPuzzlePiece />
                        </div>
                        <h5 className="fw-bold mb-2 card-title">
                          Tailored for You
                        </h5>
                        <p className="card-text">
                          Custom software solutions precisely matched to your
                          business requirements.
                        </p>
                      </div>
                    </Col>
                    <Col
                      xs={12}
                      sm={6}
                      lg={6}
                      className="mb-4"
                      data-aos="zoom-in-up"
                      data-aos-delay="100"
                      data-aos-duration="1200"
                    >
                      <div className="feature-card-custom text-center p-4 h-100 rounded-4 shadow-sm">
                        <div className="feature-icon-wrapper mb-3 mx-auto">
                          <FaRocket />
                        </div>
                        <h5 className="fw-bold mb-2 card-title">
                          Your Growth, Our Mission
                        </h5>
                        <p className="card-text">
                          We are your growth partner, driving success through
                          innovative and scalable solutions.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>

          {/* Clients Section */}
          <section className="clients-section py-5 bg-light">
            <Container>
              <Row
                className="mb-5 justify-content-center"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-once="true"
              >
                <Col xs={12} md={10} lg={8} className="text-center">
                  <h2 className="section-title mb-4">
                    Our <span style={{ color: "#85bf39" }}>Clients</span>
                  </h2>
                  <p className="section-text text-center">
                    We've partnered with companies for over 8 years to
                    reimagine, reshape, and redefine the way people experience
                    your business.
                  </p>
                </Col>
              </Row>
              <Slider {...Clientsetting}>
                {clients.map((client, index) => (
                  <div
                    key={client.id || index}
                    className="p-3"
                    data-aos="zoom-in"
                    data-aos-delay={index * 100}
                    data-aos-duration="800"
                    data-aos-once="true"
                  >
                    <div className="client-card shadow-sm rounded p-3 bg-white text-center">
                      <img
                        src={client.src}
                        alt={client.alt || `Client-${index + 1}`}
                        className="client-logo img-fluid mx-auto"
                        style={{ maxHeight: "80px", objectFit: "contain" }}
                        loading="lazy" // Added lazy loading
                        onError={(e) => {
                          // Fallback to first static image if dynamic fails
                          e.target.src = Clients1;
                        }}
                      />
                    </div>
                  </div>
                ))}
              </Slider>
            </Container>
          </section>

          {/* Promotion Section */}
          <section className="promotion-section py-5">
            <Container>
              <Row className="align-items-center">
                <Col lg={6} data-aos="fade-right" data-aos-duration="1000">
                  <h2 className="section-title mb-3">
                    Unlock Your Future with{" "}
                    <span style={{ color: "#85bf39" }}>
                      ATS Software Courses
                    </span>
                  </h2>
                  <p
                    className="section-text mb-4"
                    style={{ textAlign: "justify" }}
                  >
                    At Aalan Tech Soft, we offer a golden opportunity for
                    aspiring tech enthusiasts and college students to kickstart
                    their careers in software development. Our ATS software
                    courses provide comprehensive training, live project
                    experience, and personalized placement guidance to help you
                    land your dream job.
                  </p>
                  <p
                    className="section-text mb-4"
                    style={{ textAlign: "justify" }}
                  >
                    With a focus on industry relevant skills and expert
                    mentorship, our courses equip you with the tools needed to
                    excel in the competitive tech landscape. Join us and embark
                    on a rewarding journey towards a successful career in
                    software development. Enroll today and unleash your full
                    potential with Aalan Tech soft!
                  </p>
                  <Button
                    className="custom-btn shadow-sm"
                    onClick={() => {
                      navigate("/courses");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    data-aos="zoom-in-up"
                    data-aos-delay="100"
                  >
                    <span className="btn-text fw-semibold">Enroll Now</span>
                    <span className="btn-icon ms-2">
                      <FiArrowUpRight />
                    </span>
                  </Button>
                </Col>
                <Col
                  lg={6}
                  className="text-center mt-md-4 mt-4"
                  data-aos="fade-left"
                  data-aos-duration="1000"
                >
                  <div className="image-wrapper">
                    <img
                      src={PromotionSection}
                      alt="Software Training"
                      className="img-fluid promo-img"
                      loading="lazy" 
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          {/* Testimonials Section */}

          <div className="py-5">
            <section className="testimonials-section text-center">
              <div className="container mx-auto">
                <div className="flex items-center justify-between mb-4 pb-3">
                  <div>
                    <h2 className="section-title mb-2">
                      What Our <span>Clients & Students</span> Say
                    </h2>
                    <p className="section-text text-center">
                      See what our students and clients are saying about their
                      experience with us.
                    </p>
                  </div>
                </div>
                {courseReviews.length > 0 ? (
                  <Slider ref={sliderRef} {...setting}>
                    {courseReviews.map((review, index) => {
                      const fullImageSrc = cleanReviewImageUrl(review.image);
                      return (
                        <div
                          key={review._id || review.id || index}
                          className="px-3"
                          data-aos="zoom-in"
                          data-aos-delay={index * 100}
                          data-aos-duration="800"
                        >
                          <div className="testimonial-card h-90 flex flex-col justify-between p-6 bg-white shadow-md rounded-lg">
                            <div className="rating mb-2">
                              {[...Array(Number(review.rating))].map((_, i) => (
                                <span key={i} className="star">
                                  ★
                                </span>
                              ))}
                            </div>
                            <p className="feedback mb-4 text-gray-700 line-clamp-4">
                              {review.description || review.feedback}
                            </p>
                            <div className="testimonial-footer flex items-center justify-between mt-auto">
                              <div>
                                <h6 className="mb-0 font-bold">
                                  {review.name}
                                </h6>
                                <small className="text-gray-600">
                                  {review.course || review.role}
                                </small>
                              </div>
                              <img
                                src={fullImageSrc}
                                alt={review.name}
                                className="profile-img-card w-10 h-10 rounded-full object-cover"
                                loading="lazy" // Added lazy loading
                                onError={(e) => (e.target.src = review1)}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                ) : (
                  <p className="text-muted">Loading reviews...</p>
                )}
              </div>
            </section>
          </div>

          {/* Contact Form Section */}
          <section className="contact-section py-5">
            <Container>
              <Row className="align-items-stretch g-4">
                <Col
                  xs={12}
                  lg={6}
                  className="text-start d-flex flex-column"
                  data-aos="fade-right"
                  data-aos-duration="1000"
                  data-aos-once="true"
                >
                  <h2 className="section-title mb-3">
                    Start Your Learning{" "}
                    <span style={{ color: "#85bf39" }}>Journey Today!</span>
                  </h2>
                  <p
                    className="section-text mb-4"
                    style={{ textAlign: "justify" }}
                  >
                    Welcome to Aalan TechSoft! Ready to take your first step
                    towards a thriving career in software development? Simply
                    fill out the registration form now and let's make your
                    dreams a reality!
                  </p>

                  <ul className="icon-list d-none d-lg-block">
                    <li
                      className="d-flex align-items-center mb-3"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <div className="icon-box">
                        <FaUserCheck />
                      </div>
                      <span className="section-text fw-semibold">
                        Expert Trainers & Mentors
                      </span>
                    </li>
                    <li
                      className="d-flex align-items-center mb-3"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <div className="icon-box">
                        <FaLaptopCode />
                      </div>
                      <span className="section-text fw-semibold">
                        Hands-on Projects & Real-world Skills
                      </span>
                    </li>
                    <li
                      className="d-flex align-items-center mb-3"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <div className="icon-box">
                        <FaBriefcase />
                      </div>
                      <span className="section-text fw-semibold">
                        Placement Assistance & Career Guidance
                      </span>
                    </li>
                    <li
                      className="d-flex align-items-center mb-3"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <div className="icon-box">
                        <FaGraduationCap />
                      </div>
                      <span className="section-text fw-semibold">
                        Industry-recognized Certification
                      </span>
                    </li>
                  </ul>
                </Col>
                <Col
                  xs={12}
                  lg={6}
                  data-aos="fade-left"
                  data-aos-duration="1000"
                  data-aos-once="true"
                >
                  <Card className="contact-form-card custom-card-width shadow-lg rounded-4 p-4">
                    <Card.Body>
                      <h3
                        className="contact-title mb-4"
                        style={{ color: "#85bf39" }}
                      >
                        Course Registration Form
                      </h3>
                      {submitMessage && (
                        <Alert variant="success">{submitMessage}</Alert>
                      )}
                      {submitError && (
                        <Alert variant="danger">{submitError}</Alert>
                      )}
                      <Form onSubmit={handleFormSubmit}>
                        <Form.Group className="mb-3">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter your name"
                            className="bg-white"
                            value={formData.name}
                            onChange={(e) =>
                              handleInputChange("name", e.target.value)
                            }
                            required
                          />
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Label>Email ID</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="Enter your email"
                            className="bg-white"
                            value={formData.email}
                            onChange={(e) =>
                              handleInputChange("email", e.target.value)
                            }
                            required
                          />
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Label>Phone Number</Form.Label>
                          <Form.Control
                            type="tel"
                            placeholder="Enter your phone number"
                            className="bg-white"
                            value={formData.phone}
                            onChange={(e) =>
                              handleInputChange("phone", e.target.value)
                            }
                            pattern="[0-9]{10}"
                            maxLength={10}
                            required
                          />
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Label>Interested Course</Form.Label>
                          <Form.Select
                            value={formData.course}
                            onChange={(e) =>
                              handleInputChange("course", e.target.value)
                            }
                            required
                          >
                            <option value="">Select a course</option>
                            {(courses.length > 0 ? courses : courses1).map(
                              (course) => (
                                <option
                                  key={course.id}
                                  value={course.title
                                    .toLowerCase()
                                    .replace(/\s+/g, "-")}
                                >
                                  {course.title}
                                </option>
                              )
                            )}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Label>Preferred Mode of Learning</Form.Label>
                          <Form.Select
                            value={formData.learningMode}
                            onChange={(e) =>
                              handleInputChange("learningMode", e.target.value)
                            }
                            required
                          >
                            <option value="">Choose a mode</option>
                            <option value="online">Online</option>
                            <option value="offline">Offline</option>
                          </Form.Select>
                        </Form.Group>
                        <Button
                          type="submit"
                          className="btn btn-md sendmessage w-100"
                          data-aos="zoom-in"
                          data-aos-delay="100"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : "Register"}
                        </Button>
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>

          {/* Blog Section */}
          <section className="blog-section py-5 bg-light">
            <Container>
              <div className="text-center mb-5" data-aos="fade-down">
                <h2 className="section-title">
                  Our Latest <span style={{ color: "#85bf39" }}>Blogs</span>
                </h2>
                <p className="Section-text">
                  Stay updated with the latest trends, tips, and insights from
                  Aalan TechSoft.
                </p>
              </div>
              <Row>
                {recentPosts.length > 0 ? (
                  recentPosts.map((item, index) => (
                    <Col
                      xs={12}
                      md={6}
                      lg={4}
                      key={item._id || index}
                      className="mb-4"
                      data-aos="zoom-in"
                      data-aos-delay={100 + index * 100}
                    >
                    
                      <Card
                        className="shadow-sm border-0 h-100"
                        data-aos="fade-up"
                        data-aos-delay={index * 100}
                      >
                        <Card.Img
                          variant="top"
                          src={cleanImageUrl(item.cover_image)}
                          alt={item.blog_title}
                          style={{
                            height: "200px",
                            objectFit: "cover",
                            borderTopRightRadius: "10px",
                            borderTopLeftRadius: "10px",
                          }}
                          loading="lazy"
                          onError={(e) => {
                            e.target.src = BlogImage;
                          }}
                        />

                        <Card.Body className="d-flex flex-column">
                          {/* Top Row */}
                          <div className="d-flex justify-content-between mb-2">
                            <span className="badge badge-title text-white">
                              {item.category}
                            </span>

                            <small className="text-muted">
                              {item.post_date} •{" "}
                              {Math.floor(Math.random() * 10) + 5} min read
                            </small>
                          </div>

                          {/* Title */}
                          <Card.Title className="fw-bold mt-3">
                            {item.blog_title}
                          </Card.Title>

                          {/* Description – only 2 lines */}
                          <Card.Text
                            className="text-dark"
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: "2",
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              minHeight: "48px",
                            }}
                          >
                            {item.blog_para}
                          </Card.Text>

                          {/* Read More */}
                          <div className="mt-auto d-flex justify-content-start">
                            <span
                              className="fw-bold"
                              style={{
                                cursor: "pointer",
                                color: "#85bf39",
                                fontSize: "16px",
                              }}
                              onClick={() => navigate(`/blogs/${item._id}`)}
                            >
                              Read More
                            </span>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))
                ) : (
                  <Col xs={12}>
                    <p className="text-muted text-center">Loading blogs...</p>{" "}
                    {/* Or fallback message */}
                  </Col>
                )}
              </Row>
            </Container>
          </section>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Home;